<template>
  <img
    ref="img"
    class="image-widget"
    :style="style"
    :src="widget.url"
    @load="onImageLoad"
  >
</template>

<script>
export default {
  name: 'ImageWidgetView',
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      naturalWidth: null,
      naturalHeight: null,
    };
  },
  computed: {
    computedWidth() {
      return this.widget.width || this.naturalWidth || 'auto';
    },
    computedHeight() {
      return this.widget.height || this.naturalHeight || 'auto';
    },
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.computedHeight}px`,
        width: `${this.computedWidth}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        borderRadius: this.widget.borderRadius,
      };
    },
  },
  methods: {
    onImageLoad() {
      // Store the natural dimensions for use in computed properties
      this.naturalWidth = this.$refs.img.naturalWidth;
      this.naturalHeight = this.$refs.img.naturalHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-widget {
  position: absolute;
  display: flex;
}
</style>
